const rest = {
    show: false,
    mask: true,
    timeOut: 2000,
    cancelState: false,
    callback: ''
};
export default {
    cancel(state) {
        if (state.to && state.timeOut !== true) {
            clearTimeout(state.to);
        }
        if (state.callback) {
            state.callback('cancel');
        }
        Object.assign(state, rest);
    },
    close(state) {
        if (state.to && state.timeOut !== true) {
            clearTimeout(state.to);
        }
        if (state.callback) {
            state.callback('close');
        }
        Object.assign(state, rest);
    },
    show(state, param = {}) {
        state.cancelState = param.cancelState || false;
        state.callback = param.callback || '';
        state.timeOut = param.timeOut || 2000;
        Object.assign(state, param, {
            show: true
        });

        if (state.timeOut === true) return;
        if (state.to) clearTimeout(state.to);

        state.to = setTimeout(() => {
            if (state.callback) {
                state.callback('auto');
            }
            Object.assign(state, rest);
        }, state.timeOut);
    },
};



// WEBPACK FOOTER //
// ./src/ui/toast/store/mutations.js